<script>
import FormLayout from "./_FormLayout.vue";

export default {
  name: "DriverMasterGeneralWasteNew",
  components: {
    FormLayout,
  },
  mixins: [
  ],
  data () {
    return {
      product: null,
      breadcrumbs: [
        { text: "一般廃棄物処分業者一覧", disabled: false, to: "/driver/masters/general_waste_disposals", exact: true },
        { text: "一般廃棄物処分業者追加", disabled: true, to: "" },
      ],
      generalWasteDisposalId: null,
    }
  },
  created() {
  },
  methods: {

    /**
     * 閉じるボタン クリックイベントのコールバック
     */
    closeCallback () {
      this.$router.push({ name: 'DriverMasterGeneralWasteDisposals' })
    },

    /**
     * 登録ボタン クリックイベントのコールバック
     */
    registerCallback (id) {
      this.$router.replace({name: 'DriverMasterGeneralWasteDisposalEdit', params: { id: id }})
    },
  }
}
</script>

<template>
  <v-container>
    <v-breadcrumbs
      class="px-0 py-2"
      :items="breadcrumbs"
    />
    <form-layout
      :target-trader-id="generalWasteDisposalId"
      @closeCallback="closeCallback"
      @registerCallback="registerCallback"
    />
  </v-container>
</template>

<style scoped lang="scss">

</style>
